<template>
    <span class="text-caption font-weight-light" v-if="item && item.createdDate">
        <span class="font-weight-medium">
            <created-date :created-date="item.createdDate"></created-date>
        </span>
        <template v-if="item.createdBy">
            By
            <span class="font-weight-medium">
                <user-display-name :user="item.createdBy"></user-display-name>
            </span>
        </template>
    </span>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
}
</script>
